import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import intervalPlural from 'i18next-intervalplural-postprocessor';

import components_en from './en/components.json';
import components_pt_BR from './pt-BR/components.json';

import errors_en from './en/common.json';
import errors_pt_BR from './pt-BR/common.json';

let locale_en = {
    ...components_en, 
    common:errors_en
};
let locale_pt_BR = {
    ...components_pt_BR, 
    common:errors_pt_BR
};


const resources = {
    "pt-BR":locale_pt_BR,
    "en":locale_en
};

i18n
.use(initReactI18next)// passes i18n down to react-i18next
.use(intervalPlural)
.init({
    lng:'pt-BR',
    fallbackLng:'pt-BR', 
    defaultNS:'common',
    fallbackNS:'common',
    debug:false,
    resources
})

export default i18n;
